import { render, staticRenderFns } from "./VisitedDealershipComponent.vue?vue&type=template&id=42c34d06"
import script from "./VisitedDealershipComponent.vue?vue&type=script&lang=ts"
export * from "./VisitedDealershipComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports